import React, { useState, useMemo } from 'react';
import { Layout, Typography, Card, Row, Col, Button, Pagination, Tabs, Select, Input, Tag } from 'antd';
import { FaBookReader, FaCheckCircle } from 'react-icons/fa';
import { SearchOutlined } from '@ant-design/icons';

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

const coursesData = {
  "AI & Machine Learning": [
    { id: 1, title: "Machine Learning Basics", description: "Introduction to ML algorithms and models.", duration: "6 Weeks", level: "Beginner", enrolled: 250, type: "Free" },
    { id: 2, title: "Deep Learning Specialization", description: "Advanced neural networks and deep learning.", duration: "10 Weeks", level: "Advanced", enrolled: 180, type: "Premium" },
    { id: 3, title: "Computer Vision", description: "Learn image processing and object detection.", duration: "7 Weeks", level: "Intermediate", enrolled: 200, type: "Premium" },
    { id: 13, title: "Natural Language Processing with TensorFlow", description: "Build NLP models using TensorFlow.", duration: "8 Weeks", level: "Intermediate", enrolled: 170, type: "Premium" },
    { id: 14, title: "Reinforcement Learning", description: "Learn reinforcement learning techniques.", duration: "9 Weeks", level: "Advanced", enrolled: 140, type: "Premium" },
    { id: 15, title: "AI for Healthcare", description: "Apply AI to healthcare problems.", duration: "7 Weeks", level: "Intermediate", enrolled: 190, type: "Premium" },
    { id: 22, title: "Linear Algebra", description: "Master linear algebra for AI and ML applications.", duration: "5 Weeks", level: "Beginner", enrolled: 220, type: "Free" },
    { id: 23, title: "Probability", description: "Understand probability theory for machine learning.", duration: "6 Weeks", level: "Intermediate", enrolled: 160, type: "Premium" },
    { id: 24, title: "Statistics", description: "Learn statistical methods for AI modeling.", duration: "6 Weeks", level: "Intermediate", enrolled: 180, type: "Premium" },
    { id: 25, title: "Signal Processing", description: "Explore signal processing for AI applications.", duration: "7 Weeks", level: "Advanced", enrolled: 130, type: "Premium" },
    { id: 26, title: "Frameworks and Libraries (TensorFlow, SciPy, NumPy)", description: "Master key AI frameworks and libraries.", duration: "8 Weeks", level: "Intermediate", enrolled: 200, type: "Premium" },
    { id: 27, title: "Neural Networks", description: "Build and optimize neural network models.", duration: "9 Weeks", level: "Advanced", enrolled: 150, type: "Premium" },
    { id: 28, title: "Machine Learning", description: "Comprehensive guide to machine learning techniques.", duration: "7 Weeks", level: "Intermediate", enrolled: 240, type: "Premium" },
    { id: 29, title: "Deep Learning", description: "In-depth study of deep learning architectures.", duration: "10 Weeks", level: "Advanced", enrolled: 170, type: "Premium" },
    // New AI & Machine Learning Courses
    { id: 35, title: "Introduction to AI", description: "Learn the fundamentals of artificial intelligence.", duration: "4 Weeks", level: "Beginner", enrolled: 300, type: "Free" },
    { id: 36, title: "Generative AI with GANs", description: "Explore generative adversarial networks for AI.", duration: "8 Weeks", level: "Advanced", enrolled: 120, type: "Premium" },
    { id: 37, title: "AI Ethics and Fairness", description: "Study ethical considerations in AI development.", duration: "5 Weeks", level: "Intermediate", enrolled: 140, type: "Premium" },
    { id: 38, title: "Time Series Analysis with ML", description: "Apply ML to time series forecasting.", duration: "7 Weeks", level: "Intermediate", enrolled: 160, type: "Premium" },
    { id: 39, title: "Transfer Learning in Deep Learning", description: "Leverage pre-trained models for efficiency.", duration: "6 Weeks", level: "Advanced", enrolled: 110, type: "Premium" },
    { id: 40, title: "AI for Robotics", description: "Build AI systems for robotic applications.", duration: "9 Weeks", level: "Advanced", enrolled: 130, type: "Premium" },
    { id: 41, title: "Python for Machine Learning", description: "Master Python tools for ML projects.", duration: "6 Weeks", level: "Beginner", enrolled: 280, type: "Free" },
    { id: 42, title: "AutoML Fundamentals", description: "Learn automated machine learning techniques.", duration: "5 Weeks", level: "Intermediate", enrolled: 150, type: "Premium" },
    { id: 43, title: "AI-Powered Recommendation Systems", description: "Build systems for personalized recommendations.", duration: "7 Weeks", level: "Intermediate", enrolled: 170, type: "Premium" },
  ],
  "Cybersecurity": [
    { id: 4, title: "Ethical Hacking", description: "Hands-on ethical hacking training.", duration: "8 Weeks", level: "Intermediate", enrolled: 150, type: "Premium" },
    { id: 5, title: "Cyber Threat Intelligence", description: "Learn how to detect and prevent cyber threats.", duration: "6 Weeks", level: "Advanced", enrolled: 120, type: "Premium" },
    { id: 6, title: "Network Security", description: "Protect and secure network infrastructure.", duration: "5 Weeks", level: "Beginner", enrolled: 300, type: "Free" },
    { id: 16, title: "Cloud Security", description: "Secure cloud platforms and services.", duration: "7 Weeks", level: "Intermediate", enrolled: 160, type: "Premium" },
    { id: 17, title: "Malware Analysis", description: "Analyze and detect malware in various systems.", duration: "6 Weeks", level: "Advanced", enrolled: 130, type: "Premium" },
    { id: 18, title: "Incident Response", description: "Respond to and manage cybersecurity incidents.", duration: "8 Weeks", level: "Intermediate", enrolled: 170, type: "Premium" },
    { id: 30, title: "Shell Scripting", description: "Automate cybersecurity tasks with shell scripting.", duration: "5 Weeks", level: "Intermediate", enrolled: 140, type: "Premium" },
    // New Cybersecurity Courses
    { id: 44, title: "Introduction to Cybersecurity", description: "Learn the basics of cybersecurity principles.", duration: "4 Weeks", level: "Beginner", enrolled: 320, type: "Free" },
    { id: 45, title: "Penetration Testing", description: "Master techniques for penetration testing.", duration: "7 Weeks", level: "Intermediate", enrolled: 140, type: "Premium" },
    { id: 46, title: "Cryptography Essentials", description: "Understand encryption and secure communication.", duration: "6 Weeks", level: "Intermediate", enrolled: 150, type: "Premium" },
    { id: 47, title: "Advanced Threat Hunting", description: "Proactively hunt for cyber threats.", duration: "9 Weeks", level: "Advanced", enrolled: 100, type: "Premium" },
    { id: 48, title: "IoT Security", description: "Secure Internet of Things devices.", duration: "6 Weeks", level: "Intermediate", enrolled: 130, type: "Premium" },
    { id: 49, title: "Cybersecurity for Beginners", description: "Foundational skills in cybersecurity.", duration: "5 Weeks", level: "Beginner", enrolled: 270, type: "Free" },
    { id: 50, title: "Web Application Security", description: "Protect web apps from vulnerabilities.", duration: "7 Weeks", level: "Intermediate", enrolled: 160, type: "Premium" },
    { id: 51, title: "Blockchain Security", description: "Secure blockchain-based systems.", duration: "8 Weeks", level: "Advanced", enrolled: 110, type: "Premium" },
  ],
  "Data Science": [
    { id: 7, title: "Data Science Foundations", description: "Statistics, data analysis, and visualization.", duration: "5 Weeks", level: "Beginner", enrolled: 220, type: "Free" },
    { id: 8, title: "Big Data & Analytics", description: "Handle large-scale data using Spark and Hadoop.", duration: "8 Weeks", level: "Advanced", enrolled: 90, type: "Premium" },
    { id: 9, title: "Natural Language Processing", description: "Text data analysis with NLP techniques.", duration: "6 Weeks", level: "Intermediate", enrolled: 160, type: "Premium" },
    { id: 19, title: "Data Visualization with Tableau", description: "Create insightful data visualizations.", duration: "5 Weeks", level: "Intermediate", enrolled: 150, type: "Premium" },
    { id: 20, title: "Predictive Analytics", description: "Use statistical techniques for predictions.", duration: "7 Weeks", level: "Advanced", enrolled: 110, type: "Premium" },
    { id: 21, title: "Data Mining", description: "Extract valuable information from large datasets.", duration: "6 Weeks", level: "Intermediate", enrolled: 140, type: "Premium" },
    { id: 31, title: "Big Data Programming Languages (Python, R, Java)", description: "Master Python, R, and Java for big data.", duration: "8 Weeks", level: "Intermediate", enrolled: 180, type: "Premium" },
    { id: 32, title: "Cluster Analysis", description: "Learn clustering techniques for data science.", duration: "6 Weeks", level: "Advanced", enrolled: 120, type: "Premium" },
    { id: 33, title: "Tableau", description: "Advanced data visualization with Tableau.", duration: "5 Weeks", level: "Intermediate", enrolled: 160, type: "Premium" },
    { id: 34, title: "Microsoft Power BI", description: "Build interactive dashboards with Power BI.", duration: "5 Weeks", level: "Intermediate", enrolled: 170, type: "Premium" },
    // New Data Science Courses
    { id: 52, title: "Introduction to Data Science", description: "Learn the basics of data science workflows.", duration: "4 Weeks", level: "Beginner", enrolled: 300, type: "Free" },
    { id: 53, title: "SQL for Data Science", description: "Master SQL for data querying and analysis.", duration: "5 Weeks", level: "Beginner", enrolled: 260, type: "Free" },
    { id: 54, title: "Data Engineering Basics", description: "Build data pipelines and ETL processes.", duration: "7 Weeks", level: "Intermediate", enrolled: 140, type: "Premium" },
    { id: 55, title: "Advanced Statistical Modeling", description: "Dive into advanced statistical techniques.", duration: "8 Weeks", level: "Advanced", enrolled: 100, type: "Premium" },
    { id: 56, title: "Time Series Analysis", description: "Analyze and forecast time series data.", duration: "6 Weeks", level: "Intermediate", enrolled: 150, type: "Premium" },
    { id: 57, title: "Data Science with Python", description: "Comprehensive Python for data science.", duration: "7 Weeks", level: "Intermediate", enrolled: 200, type: "Premium" },
    { id: 58, title: "Machine Learning for Data Science", description: "Apply ML techniques to data science.", duration: "8 Weeks", level: "Advanced", enrolled: 130, type: "Premium" },
    { id: 59, title: "Data Wrangling with Pandas", description: "Clean and transform data using Pandas.", duration: "5 Weeks", level: "Intermediate", enrolled: 180, type: "Premium" },
  ],
};

const pageSize = 4;

const AllCoursesPage = () => {
  const [currentTab, setCurrentTab] = useState("AI & Machine Learning");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('enrolled'); // New state for sorting

  const handleTabChange = (key) => {
    setCurrentTab(key);
    setCurrentPage(1);
    setSelectedLevel(null);
    setSelectedType(null);
    setSearchQuery('');
    setSortBy('enrolled');
  };

  const handleLevelChange = (value) => {
    setSelectedLevel(value);
    setCurrentPage(1);
  };

  const handleTypeChange = (value) => {
    setSelectedType(value);
    setCurrentPage(1);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleSortChange = (value) => {
    setSortBy(value);
    setCurrentPage(1);
  };

  const currentCourses = coursesData[currentTab] || [];

  const filteredCourses = useMemo(() => {
    let filtered = [...currentCourses];
    if (selectedLevel) {
      filtered = filtered.filter((course) => course.level === selectedLevel);
    }
    if (selectedType) {
      filtered = filtered.filter((course) => course.type === selectedType);
    }
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        (course) =>
          course.title.toLowerCase().includes(query) ||
          course.description.toLowerCase().includes(query)
      );
    }
    // Sorting
    filtered.sort((a, b) => {
      if (sortBy === 'enrolled') return b.enrolled - a.enrolled; // High to low
      if (sortBy === 'duration') {
        const durationA = parseInt(a.duration.split(' ')[0]);
        const durationB = parseInt(b.duration.split(' ')[0]);
        return durationA - durationB; // Ascending
      }
      return 0;
    });
    return filtered;
  }, [currentCourses, selectedLevel, selectedType, searchQuery, sortBy]);

  const paginatedCourses = useMemo(() => {
    return filteredCourses.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  }, [filteredCourses, currentPage]);

  return (
    <Layout>
      <Content style={{ padding: '60px', background: 'linear-gradient(135deg, #e6fffb, #fff7e6)' }}>
        <Title level={2} style={{ fontSize: '24px', display: 'flex', alignItems: 'center', color: '#13c2c2', marginBottom: '28px', fontWeight: '700' }}>
          <FaBookReader style={{ marginRight: '14px', fontSize: '24px', color: '#fa8c16' }} /> Explore Our Courses
        </Title>
        <Paragraph style={{ fontSize: '16px', color: '#595959', marginBottom: '32px', maxWidth: '800px' }}>
          Kickstart your journey with top-tier courses in AI, Data Science, Cybersecurity, and more. Earn certifications, unlock career opportunities, and join thousands of learners today!
        </Paragraph>
        <div style={{ marginBottom: '32px', display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
          <Input
            placeholder="Search courses by title or description"
            prefix={<SearchOutlined />}
            value={searchQuery}
            style={{ width: '340px', borderRadius: '8px', height: '44px', boxShadow: '0 3px 6px rgba(0,0,0,0.1)', border: 'none' }}
            onChange={handleSearchChange}
          />
          <Select
            placeholder="Filter by Level"
            value={selectedLevel}
            style={{ width: '240px', borderRadius: '8px' }}
            onChange={handleLevelChange}
            allowClear
            dropdownStyle={{ borderRadius: '8px' }}
          >
            <Option value={null}>All Levels</Option>
            <Option value="Beginner">Beginner</Option>
            <Option value="Intermediate">Intermediate</Option>
            <Option value="Advanced">Advanced</Option>
          </Select>
          <Select
            placeholder="Filter by Type"
            value={selectedType}
            style={{ width: '240px', borderRadius: '8px' }}
            onChange={handleTypeChange}
            allowClear
            dropdownStyle={{ borderRadius: '8px' }}
          >
            <Option value={null}>All Types</Option>
            <Option value="Free">Free</Option>
            <Option value="Premium">Premium</Option>
          </Select>
          <Select
            placeholder="Sort By"
            defaultValue="enrolled"
            style={{ width: '200px', borderRadius: '8px' }}
            onChange={handleSortChange}
            dropdownStyle={{ borderRadius: '8px' }}
          >
            <Option value="enrolled">Most Enrolled</Option>
            <Option value="duration">Duration (Short to Long)</Option>
          </Select>
        </div>
        <Tabs
          activeKey={currentTab}
          onChange={handleTabChange}
          className="custom-tabs"
          tabBarStyle={{ fontWeight: '700', color: '#13c2c2', borderBottom: '3px solid #13c2c2', marginBottom: '24px' }}
        >
          {Object.keys(coursesData).map((category) => (
            <TabPane tab={category} key={category}>
              <Row gutter={[24, 24]}>
                {paginatedCourses.length > 0 ? (
                  paginatedCourses.map((course) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={course.id}>
                      <Card
                        hoverable
                        style={{
                          borderRadius: '16px',
                          overflow: 'hidden',
                          boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                          background: 'linear-gradient(135deg, #ffffff, #f0fafa)',
                          height: '380px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          padding: '20px',
                          transition: 'transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-8px)';
                          e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.2)';
                          e.currentTarget.style.background = 'linear-gradient(135deg, #f0fafa, #e6fffb)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.15)';
                          e.currentTarget.style.background = 'linear-gradient(135deg, #ffffff, #f0fafa)';
                        }}
                      >
                        <div>
                          <Title level={4} style={{ marginBottom: '12px', color: '#1a1a1a', fontSize: '20px', fontWeight: '600' }}>
                            {course.title}
                          </Title>
                          <Paragraph
                            style={{ color: '#595959', fontSize: '14px', marginBottom: '16px', lineHeight: '1.5' }}
                            ellipsis={{ rows: 2, expandable: false }}
                          >
                            {course.description}
                          </Paragraph>
                          <Paragraph style={{ marginBottom: '8px', color: '#595959', fontSize: '14px' }}>
                            <strong style={{ color: '#13c2c2' }}>Duration:</strong> {course.duration}
                          </Paragraph>
                          <Paragraph style={{ marginBottom: '8px', color: '#595959', fontSize: '14px' }}>
                            <strong style={{ color: '#13c2c2' }}>Level:</strong>{' '}
                            <Tag
                              color={
                                course.level === 'Beginner' ? '#52c41a' : course.level === 'Intermediate' ? '#fa8c16' : '#f5222d'
                              }
                              style={{ borderRadius: '4px', fontWeight: 'bold' }}
                            >
                              {course.level}
                            </Tag>
                          </Paragraph>
                          <Paragraph style={{ marginBottom: '8px', color: '#595959', fontSize: '14px' }}>
                            <strong style={{ color: '#13c2c2' }}>Type:</strong>{' '}
                            <Tag
                              color={course.type === 'Free' ? '#13c2c2' : '#722ed1'}
                              style={{ borderRadius: '4px', fontWeight: 'bold' }}
                            >
                              {course.type}
                            </Tag>
                          </Paragraph>
                          <Paragraph style={{ marginBottom: '0', color: '#888', fontSize: '13px' }}>
                            <strong style={{ color: '#13c2c2' }}>Enrolled:</strong> {course.enrolled} learners
                          </Paragraph>
                        </div>
                        <Button
                          type="primary"
                          icon={<FaCheckCircle style={{ marginRight: '8px' }} />}
                          style={{
                            background: 'linear-gradient(45deg, #fa8c16, #d46b08)',
                            border: 'none',
                            borderRadius: '8px',
                            fontWeight: 'bold',
                            height: '44px',
                            width: '100%',
                            marginTop: '20px',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = 'linear-gradient(45deg, #d46b08, #ad4e00)';
                            e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.3)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = 'linear-gradient(45deg, #fa8c16, #d46b08)';
                            e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                          }}
                        >
                          Enroll Now
                        </Button>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <Col span={24} style={{ textAlign: 'center', marginTop: '24px' }}>
                    <Paragraph style={{ color: '#999', fontSize: '16px' }}>
                      No courses match your filters. Try adjusting your search, level, type, or sort options!
                    </Paragraph>
                  </Col>
                )}
              </Row>
              <Pagination
                current={currentPage}
                total={filteredCourses.length}
                pageSize={pageSize}
                onChange={setCurrentPage}
                style={{ marginTop: '32px', textAlign: 'center', fontSize: '16px' }}
                showSizeChanger={false}
                showQuickJumper
              />
            </TabPane>
          ))}
        </Tabs>
        {/* Custom CSS */}
        <style jsx global>{`
          .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
            color: #13c2c2 !important;
          }
          .ant-tabs-ink-bar {
            background: #13c2c2 !important;
          }
          .ant-pagination-item-active {
            border-color: #fa8c16 !important;
          }
          .ant-pagination-item-active a {
            color: #fa8c16 !important;
          }
          .ant-select-selector {
            border: none !important;
            box-shadow: 0 3px 6px rgba(0,0,0,0.1) !important;
            height: 44px !important;
            display: flex !important;
            align-items: center !important;
          }
          .ant-select-selection-placeholder {
            color: #888 !important;
          }
        `}</style>
      </Content>
    </Layout>
  );
};

export default AllCoursesPage;